/**
 * @generated SignedSource<<c34eeb37cd864578202b3ef75f5d0f33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LessonAccess = "BOOKING" | "NONE" | "REQUEST";
import { FragmentRefs } from "relay-runtime";
export type useFacilityLessonPatronAccess_facility$data = {
  readonly club: {
    readonly supportsPublic: boolean;
  } | null | undefined;
  readonly privateLessonsPermissionSet: {
    readonly patronAccess: LessonAccess | null | undefined;
  } | null | undefined;
  readonly publicLessonsPermissionSet: {
    readonly patronAccess: LessonAccess | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useFacilityLessonPatronAccess_facility";
};
export type useFacilityLessonPatronAccess_facility$key = {
  readonly " $data"?: useFacilityLessonPatronAccess_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityLessonPatronAccess_facility">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronAccess",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityLessonPatronAccess_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPublic",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicLessonsPermissionSet",
      "kind": "LinkedField",
      "name": "publicLessonsPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PrivateLessonsPermissionSet",
      "kind": "LinkedField",
      "name": "privateLessonsPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "b90e7d6f52e4c6859148df1524a263cc";

export default node;
